import { http } from '@/services/http'
import { Cache } from 'axios-extensions'

const cacheAccountDetails = new Cache()

const getUser = ({ state, commit, rootState, dispatch }, params) => {
  return new Promise((resolve, reject) => {
    http
      .get('/api/user_details', { ...params, cache: cacheAccountDetails })
      .then((response) => {
        commit('STORE_USER', response.data.user)
        resolve(response)
      })
      .catch((error) => reject(error.response.data))
  })
}

export const promoCode = ({ state, commit, rootState }) => {
  return new Promise((resolve, reject) => {
    http
      .get('/api/users/promotion', { cache: cacheAccountDetails })
      .then((response) => {
        commit('STORE_PROMO_URL', response.data.promo_url)
        commit('STORE_PROMO_WIDGET', response.data.promo_widget)
        commit('STORE_PROMO_MPC', response.data.mpc_code)
        resolve(response)
      })
      .catch((error) => reject(error.response.data))
  })
}

export const generateTranche = ({ state, commit, dispatch, rootState }) => {
  return new Promise((resolve, reject) => {
    http
      .post('/api/users/generate_tranch')
      .then((response) => {
        dispatch('statistics/getPaymentSaldo', 'get')
        resolve(response)
      })
      .catch((error) => {
        reject(error.response.data)
      })
  })
}

export const reminderBeneficiaryEmail = ({ state, commit }, email) => {
  return new Promise((resolve, reject) => {
    http
      .post('/api/accountants/reminders/beneficiary_payments', { email: email })
      .then((response) => {
        resolve(response)
      })
      .catch((error) => {
        reject(error.response.data)
      })
  })
}

export const processLead = ({ state, commit }, salesforceId) => {
  return new Promise((resolve, reject) => {
    http
      .post('/api/accountants/reminders/beneficiary_payments_by_sf_ids', { salesforce_id: salesforceId })
      .then((response) => {
        resolve(response)
      })
      .catch((error) => {
        reject(error.response.data)
      })
  })
}

export const sendAccountDetails = ({ state, commit }, data) => {
  return new Promise((resolve, reject) => {
    http
      .post('/api/accounts/update_account_details', data)
      .then((response) => {
        resolve(response)
      })
      .catch((error) => {
        reject(error.response.data)
      })
  })
}

export default {
  getUser,
  promoCode,
  generateTranche,
  reminderBeneficiaryEmail,
  processLead,
  sendAccountDetails
}



// WEBPACK FOOTER //
// ./src/store/modules/account/actions.js